<template>
    <div class="tabs-container ng-scope" style="padding-bottom:50px;margin-top:18px;">
  <el-form :model="tagDetail" ref="tagDetail"  label-width="0px" class="demo-dynamic">
      <div class="form-horizontal detailPage"  >
        <div class="tab-content">
          <div
          >
            <div class="panel-body">
              <div class="ibox-content">
              
                <div class="form-group">
                  <label class="col-sm-2 control-label">Language</label>
                  <div class="col-sm-4"  v-if="!$route.query.id">
                    <el-form-item 
                      prop="langCode"
                      :rules="{
                        required: true, message: $t('message.required'), trigger: 'blur'
                      }"
                    >
                      <el-select v-model="tagDetail.langCode" clearable v-bind:placeholder='$t("message.PleaseSelect")'>
                          <el-option 
                          v-for="item in languageObj"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                          </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="col-sm-4"  v-if="$route.query.id">
                    <div>
                      <el-input  disabled :value='tagDetail.langCodeShow'></el-input>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-2 control-label">
                    Name
                  </label>
                  <div class="col-sm-4">
                    <el-form-item 
                      prop="name"
                      :rules="{
                        required: true, message: $t('message.required'), trigger: 'blur'
                      }"
                    >
                      <el-input v-model="tagDetail.name"  show-word-limit :maxlength="100"></el-input>
                    </el-form-item>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-2 control-label"> Synonyms </label>
                  <div class="col-sm-4">
                    <div>
                      <el-input
                        v-model="synonyms"
                        placeholder="Add tag ; as separator between synonyms"
                      ><el-button slot="append" @click="addSynonyms()">Add</el-button></el-input>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-2 control-label"></label>
                  <div class="col-sm-10">
                    <ul class="tag-list" style="padding: 0">
                        <li v-for = "(data,k) in tagDetail.synonyms">
                            <a ><span style="padding-right: 15px;">{{data}}</span> <i class="fa fa-trash-o" @click="deleteObj(tagDetail.synonyms, k)"></i></a>
                            
                        </li>
                    </ul>   
                  </div>
                </div>
                <div class="form-group">
                  <label class="col-sm-2 control-label">
                    Status
                  </label>
                  <div class="col-sm-4">
                    <el-form-item 
                      prop="status"
                      :rules="{
                        required: true, message: $t('message.required'), trigger: 'change'
                      }"
                    >
                      <el-select v-model="tagDetail.status" clearable >
                          <el-option 
                          v-for="item in statusObj"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                          </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </div>
                <div class="hr-line-dashed"></div>
              
                <div class="form-group">
                  <div class="col-sm-12">
                    <div class="pull-right">
                      <div class="btn btn-primary" v-if="!$route.query.id&&checkPermission('TAG_LIST_NEW')||$route.query.id&&checkPermission('TAG_LIST_UPDATE')"  @click="checkEvent()">{{$t("message.Save") }}</div>
                      <div class="btn btn-white" @click="showWarning()">{{$t("message.Cancel") }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";


export default {
  mixins: [config.globalMixin],
  data() {
    return {
      tagDetail:{
      },
      statusObj:[],
      languageObj:[],
      typeObj:[],
      synonyms:""
    };
  },
  created() {
    this.init();
  },
  watch: {
    tagDetail: {
        handler: function(val, oldval) {
          this.$store.state.edit = true;
        },
        deep: true
    }
  },
  mounted() {
    setTimeout(function(){
      $(".tab" + 1)
        .parent()
        .find("a")
        .click();

      $(".tab" + 0)
        .parent()
        .find("a")
        .click();
    })
  },
  methods: {
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj();
        obj.tagId = id;
        obj.apiUrl = '/getTagDetail'
        var data = await this.$store.dispatch("apiEvent", obj);
        if(!data) return;
        data.data.result.status+="";
        data.data.result.type+="";
        if(data.data.result.synonyms){
          data.data.result.synonyms = data.data.result.synonyms.split(";")
        }
        
        data.data.result.langCodeShow = this.$i18n.t("message."+data.data.result.langCode)
        this.$set(this, "tagDetail", data.data.result);
        var that = this;
        setTimeout(function(){
          that.$store.state.edit = false;
        })
      } else {
      }
      this.setObj();
    },
    goBack() {
      this.$router.push({
        path: "/main/tagList",
        query: { ...this.$route.query }
      });
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        this.goBack();
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [{
              name:this.$i18n.t("message.Confirm"),
              callBack:function(){
                that.callDelete();
              }
            }, {
              name:this.$i18n.t("message.Cancel"),
              callBack:function(){}
            }]
        });
      }
    },
    checkEvent:function(){

        this.$refs["tagDetail"].validate((valid) => {
          if (valid) {
            this.submit();
          } else {
            // this.$toastr.w("请完成必填项");
            return false;
          }
        });
    },
    deleteObj: function (obj, index) {
      obj.splice(index, 1);
    },
    addSynonyms(){
      if(!this.synonyms) return;
      if(!this.tagDetail.synonyms){
        this.tagDetail.synonyms = [];
      }
      var synonyms = this.synonyms.split(";")
      synonyms.forEach(item=>{
        this.tagDetail.synonyms.push(item)
      })
      this.synonyms = ""
    },
    async submit() {
        let obj = this.getAuthObj();
        for(var key in this.tagDetail){
          var detail = JSON.stringify(this.tagDetail[key])
          obj[key] = JSON.parse(detail);
        }
        if(obj.synonyms){
          obj.synonyms = obj.synonyms.join(';')
        }
        if(this.$route.query.id){
          obj.tagId = this.$route.query.id;
          obj.apiUrl = '/updateTag'
          var data = await this.$store.dispatch("apiEvent", obj);
        }else{
          obj.apiUrl = '/createTag'
          var data = await this.$store.dispatch("apiEvent", obj);
        }
        if(!data) return;
        if (data.data.errorCode === 0) {
          this.$store.state.edit = false;
          this.goBack();
        }
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {
      try {
        let obj = this.getAuthObj();
        obj.ids = this.$route.query.id;
        obj.apiUrl = '/deleteTag'
        var data = await this.$store.dispatch("apiEvent", obj);
        if(!data) return;
        if (data.data.errorCode === 0) {
          this.$store.state.edit = false;
          this.goBack();
        }
      } catch (err) {
      }
    },
    setObj:function(){
      this.statusObj=[{
        value: '1',
        label: this.$i18n.t("message.Active")
      }, {
        value: '0',
        label: this.$i18n.t("message.Inactive")
      }]
      this.typeObj=[{
        value: '0',
        label: 'type1'
      }, {
        value: '1',
        label: 'type2'
      }]
      this.languageObj=[{
        value: 'en_US',
        label: this.$i18n.t("message.en_US")
      }, {
        value: 'zh_HK',
        label: this.$i18n.t("message.zh_HK")
      }, {
        value: 'zh_CN',
        label: this.$i18n.t("message.zh_CN")
      }]
    }
  }
};
</script>
